
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentinpune() {



    const cardData =
    {
        keyword: 'Tempo Traveller On Rent in Pune',
        heading: 'Platinum24 Cabs: Tempo Traveller On Rent in Pune',
        headingDescription: ' Platinum24 Cabs offers spacious Tempo Traveller on Rent in Pune, ideal for family tours, corporate outings, school trips, and pilgrimage journeys. Our fleet includes 12, 17, 20, and 26-seater AC and non-AC Tempo Travellers equipped with comfortable push-back seats, ample legroom, and large luggage space for a smooth travel experience. With professional chauffeurs, punctual pickups, and affordable packages, we make group travel convenient and enjoyable. Whether it’s a weekend getaway to nearby hill stations, a multi-day outstation trip, or a religious yatra, Platinum24 Cabs ensures safety, reliability, and comfort throughout your journey.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort palace. Once the seat of the Maratha Empire, its massive gates, fountains, and ruins narrate tales of grandeur. Though destroyed by fire in 1828, it still draws thousands of visitors. The evening light-and-sound show recreates the legacy of Bajirao and Mastani. Tourists love exploring its historic courtyards and gardens. Shaniwar Wada is Pune’s proud heritage symbol."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum showcasing Gandhi’s belongings and photographs. The Italian arches and sprawling lawns add architectural beauty. It is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s historical and inspirational landmark."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is famous for the 1670 battle where Tanaji Malusare fought bravely for Chhatrapati Shivaji Maharaj. The fort offers trekking trails, temples, and panoramic views of the Sahyadris. In monsoon, mist and waterfalls make the climb enchanting. Visitors also enjoy local delicacies like pithla-bhakri at the fort. It is a blend of adventure and history. Sinhagad is Pune’s must-visit trekking and heritage spot."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The magnificent idol is adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the center of grand festivities with thousands of devotees. The temple is also known for its charitable activities. It is a spiritual and cultural icon of the city. Dagdusheth Ganpati is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The temple features massive stone pillars, a sanctum, and a Nandi mandapa. Despite being in the city center, it offers peace and spirituality. Its architecture reflects ancient Indian craftsmanship. Evening chants create a mystical aura. Pataleshwar is Pune’s hidden spiritual gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, sculptures, musical instruments, and everyday antiques. The recreated Mastani Mahal is a highlight. It is an educational and fascinating spot for history enthusiasts. The museum preserves Indian traditions across centuries. It is Pune’s cultural treasure house."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city. At its summit stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa era, it also houses museums and smaller shrines. Climbing 103 steps to the top is both devotional and adventurous. Sunrise and sunset views here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global center for wellness and spirituality. Spread across lush gardens, it attracts seekers worldwide. It offers meditation, yoga sessions, and personal growth workshops. The ashram’s Zen gardens and serene meditation halls provide tranquility. It is ideal for rejuvenation and mindfulness. Osho Ashram is Pune’s international hub of peace and harmony."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, stone bridges, and manicured lawns make it a peaceful retreat. Families enjoy strolls, photography, and picnics here. The garden represents Indo-Japanese cultural friendship. Seasonal flowers enhance its beauty year-round. Pu La Deshpande Garden is Pune’s green oasis of calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a favorite weekend destination near Pune. It supplies water to the city while offering picturesque landscapes. During monsoon, the overflowing dam becomes a spectacular sight. Street food stalls selling corn and tea make it lively. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural getaway."
  }
],



   "services": [
    {
      "name": "Tempo Traveller Rental Pune",
      "description": "Reliable Tempo Traveller rental services in Pune offering spacious and comfortable vehicles ideal for group travel. Perfect for family outings, corporate events, or tourist excursions, our Tempo Travellers come fully equipped with air conditioning and ample luggage space. We ensure well-maintained vehicles driven by experienced and courteous drivers, providing a safe, smooth, and enjoyable journey throughout Pune and nearby regions."
    },
    {
      "name": "Pune Tempo Traveller Hire",
      "description": "Convenient Tempo Traveller hire service in Pune designed to cater to groups of all sizes with flexible booking options. Whether you need the vehicle for a few hours, a full day, or multiple days, our packages are tailored to fit your requirements. Our professional drivers are knowledgeable about local routes, ensuring timely pickups and drop-offs while maintaining the highest standards of safety and comfort."
    },
    {
      "name": "Tempo Traveller On Rent Pune",
      "description": "Affordable Tempo Traveller rental solutions available across Pune for family trips, sightseeing tours, corporate outings, and pilgrimage journeys. Vehicles are regularly serviced and sanitized for passenger safety, equipped with modern amenities such as air conditioning, comfortable seating, and entertainment options. We offer both self-drive and chauffeur-driven choices to match your preference."
    },
    {
      "name": "Pune Tempo Traveller Booking",
      "description": "Easy and quick Tempo Traveller booking service in Pune with instant confirmation and flexible pickup locations. Choose from a range of vehicle models based on group size and trip type. Our user-friendly booking platform and dedicated customer support make organizing your group travel hassle-free, ensuring your journey is seamless from start to finish."
    },
    {
      "name": "Tempo Traveller for Group Travel Pune",
      "description": "Spacious and comfortable Tempo Travellers ideal for group travel within and around Pune. Perfect for family reunions, corporate team outings, school trips, and social events, these vehicles offer ample seating and luggage space. Professional drivers ensure punctual pickups, safe travel, and smooth navigation through city and highway routes, making group journeys stress-free and enjoyable."
    },
    {
      "name": "Pune Tempo Traveller Service",
      "description": "Comprehensive Tempo Traveller service in Pune featuring well-maintained vehicles and professional chauffeurs trained for customer safety and comfort. We provide tailored packages for different trip types including local sightseeing, outstation tours, airport transfers, and special events. Our commitment to quality service ensures timely arrivals, clean interiors, and a pleasant travel experience for all passengers."
    },
    {
      "name": "Affordable Tempo Traveller Pune",
      "description": "Budget-friendly Tempo Traveller rental options in Pune without compromising on vehicle quality or service standards. We offer transparent pricing with no hidden charges, flexible rental durations, and competitive rates for different vehicle sizes. Our affordable service is perfect for cost-conscious travelers seeking reliable transportation for group journeys across Pune and neighboring areas."
    },
    {
      "name": "Tempo Traveller on Rent for Tours Pune",
      "description": "Specialized Tempo Traveller rental services for tour groups in Pune, designed to cover popular tourist destinations, pilgrimage spots, and leisure outings. Vehicles come equipped with air conditioning and comfortable seating arrangements to ensure a pleasant experience during long journeys. Our experienced drivers act as guides to assist with local insights and ensure a smooth travel itinerary."
    },
    {
      "name": "Pune Tempo Traveller Rent Rates",
      "description": "Detailed and transparent rent rates for Tempo Travellers in Pune based on vehicle type, rental duration, and travel distance. Our pricing includes driver allowance, fuel charges, tolls, and taxes to offer an all-inclusive cost structure. Flexible packages are available for hourly, daily, and long-term rentals, catering to the diverse needs of families, corporates, and tour operators."
    },
    {
      "name": "Pune Tempo Traveller with Driver",
      "description": "Professional Tempo Traveller rental service with experienced drivers in Pune, ensuring safe and comfortable journeys. Drivers are courteous, punctual, and well-versed with local traffic conditions and routes. This service is ideal for travelers who prefer to relax during their trip without worrying about navigation or driving, providing peace of mind and convenience."
    },
    {
      "name": "Tempo Traveller for Family Trips Pune",
      "description": "Spacious and comfortable Tempo Travellers tailored for family trips around Pune and beyond. Offering ample seating and luggage space, our vehicles ensure that families can travel together without compromising on comfort. Our vehicles are regularly sanitized and maintained to provide a safe travel environment, with friendly drivers assisting with any special requirements."
    },
    {
      "name": "Pune Tempo Traveller for Corporate Events",
      "description": "Dedicated Tempo Traveller rental services for corporate events in Pune, providing reliable and professional transport solutions for business meetings, conferences, team outings, and client pickups. Vehicles are equipped to offer comfort during long journeys and meet corporate standards of punctuality, professionalism, and safety. Customized packages are available to suit specific corporate travel needs."
    },
    {
      "name": "Tempo Traveller for Pilgrimage Trips Pune",
      "description": "Specialized Tempo Traveller rentals for pilgrimage trips from Pune, designed to accommodate large groups comfortably for long-distance travel. Vehicles are equipped with air conditioning and sufficient luggage space to ensure a pleasant and hassle-free pilgrimage journey. Our drivers are experienced in handling routes to religious destinations and offer timely services that respect travelers’ schedules."
    },
    {
      "name": "Tempo Traveller for School Trips Pune",
      "description": "Safe and reliable Tempo Traveller services specifically for school trips in Pune, focusing on student safety, punctuality, and comfort. Our vehicles undergo regular safety checks and are driven by trained chauffeurs who ensure attentive and responsible driving. We offer flexible booking options and support for multiple stops, catering to various school excursion needs."
    },
    {
      "name": "Tempo Traveller Hire Pune with AC",
      "description": "Comfortable and air-conditioned Tempo Traveller hire services in Pune providing a cool and refreshing travel experience regardless of the weather. These vehicles are perfect for group travel during summer months or long journeys where climate control is essential for passenger comfort. All vehicles are well-maintained with professional drivers ensuring a smooth and pleasant ride."
    }
  ],
  "tableData": [
    ["Tempo Traveller Rental Pune", "Pune Tempo Traveller Hire"],
    ["Tempo Traveller On Rent Pune", "Pune Tempo Traveller Booking"],
    ["Tempo Traveller for Group Travel Pune", "Pune Tempo Traveller Service"],
    ["Affordable Tempo Traveller Pune", "Tempo Traveller on Rent for Tours Pune"],
    ["Pune Tempo Traveller Rent Rates", "Pune Tempo Traveller with Driver"],
    ["Tempo Traveller for Family Trips Pune", "Pune Tempo Traveller for Corporate Events"],
    ["Tempo Traveller for Pilgrimage Trips Pune", "Tempo Traveller for School Trips Pune"],
    ["Tempo Traveller Hire Pune with AC", "—"]
  ],


     "whychoose": [
    {
      "WhyChooseheading": "Spacious Tempo Travellers on Rent in Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers well-maintained and spacious tempo travellers ideal for group travel in and around Pune."
    },
    {
      "WhyChooseheading": "Perfect for Family Trips, Group Tours, and Corporate Outings",
      "WhyChoosedescription": "Our tempo travellers are designed for comfort and convenience, making them ideal for all kinds of group journeys."
    },
    {
      "WhyChooseheading": "Multiple Seating Options Available (9 to 26 Seaters)",
      "WhyChoosedescription": "Choose from a range of tempo travellers based on your group size and travel requirements."
    },
    {
      "WhyChooseheading": "Comfortable Seating with Ample Legroom and Luggage Space",
      "WhyChoosedescription": "Travel in comfort with pushback seats, wide legroom, and enough space for all your bags."
    },
    {
      "WhyChooseheading": "Experienced Drivers for Safe and Smooth Rides",
      "WhyChoosedescription": "Our drivers are skilled in handling long-distance and group travel, ensuring safety and punctuality."
    },
    {
      "WhyChooseheading": "Clean and Sanitized Vehicles for Hygiene and Safety",
      "WhyChoosedescription": "Every tempo traveller is thoroughly cleaned and sanitized before and after each trip."
    },
    {
      "WhyChooseheading": "Affordable Rates with Transparent Billing",
      "WhyChoosedescription": "Enjoy competitive rental rates with no hidden charges—what you see is what you pay."
    },
    {
      "WhyChooseheading": "Available for Local, Outstation, and Multi-Day Trips",
      "WhyChoosedescription": "Whether it’s a day trip or a long journey, our tempo travellers are ready to go the distance."
    }
  ]



















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer Tempo Traveller on rent in Pune?',
        answer: 'Yes, Platinum24 Cabs provides Tempo Traveller rentals in Pune for group travel, events, and sightseeing.',
    },
    {
        question: 'How can I book a Tempo Traveller on rent in Pune with Platinum24 Cabs?',
        answer: 'You can book a Tempo Traveller through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What is the seating capacity of the Tempo Traveller available for rent?',
        answer: 'Our Tempo Travellers typically accommodate 9 to 15 passengers, perfect for group travel and tours.',
    },
    {
        question: 'Are the Tempo Travellers well-maintained and comfortable?',
        answer: 'Yes, all our Tempo Travellers are regularly serviced, clean, and equipped with comfortable seating for a pleasant journey.',
    },
    {
        question: 'Can I hire a Tempo Traveller for local Pune travel as well as outstation trips?',
        answer: 'Absolutely! We offer Tempo Traveller rentals for both local travel within Pune and long-distance trips.',
    },
    {
        question: 'What are the rental packages available for Tempo Traveller in Pune?',
        answer: 'We provide flexible hourly, daily, and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Are drivers provided with the Tempo Traveller rental?',
        answer: 'Yes, all rentals come with experienced professional drivers to ensure a safe and hassle-free trip.',
    },
    {
        question: 'Can I customize pickup and drop-off locations when renting a Tempo Traveller?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points to suit your itinerary.',
    },
    {
        question: 'What safety measures are followed for Tempo Traveller rentals?',
        answer: 'Our vehicles are regularly sanitized, and drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is corporate Tempo Traveller rental available in Pune?',
        answer: 'Yes, we offer customized corporate rental solutions for Tempo Travellers, including priority support and billing flexibility.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rahul Patil',
        feedback: 'Renting a Tempo Traveller from Platinum24 Cabs in Pune was seamless. The vehicle was spacious and the driver courteous.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Joshi',
        feedback: 'Great experience with the Tempo Traveller rental service. Perfect for our family trip around Pune.',
        rating: 5,
    },
];


































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const tempoTravellerOnRentPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller On Rent in Pune",
  "image": "https://www.platinum24cab.com/assets/images/tempo-traveller-pune.jpg",
  "description": "Rent Tempo Travellers in Pune for group travel, corporate events, family trips, pilgrimages, and school trips. Affordable rates with AC options and professional drivers at Platinum24 Cabs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/tempo-traveller-on-rent-pune"
  }
};








    return (
        <div>

<Helmet>
  <title>Tempo Traveller On Rent in Pune | Group & Corporate Travel | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Rent Tempo Travellers in Pune for group travel, corporate events, family trips, pilgrimages, and school trips. Affordable rates with AC options and professional drivers at Platinum24 Cabs."
  />
  <meta
    name="keywords"
    content="Tempo Traveller Rental Pune, Pune Tempo Traveller Hire, Tempo Traveller On Rent Pune, Pune Tempo Traveller Booking, Tempo Traveller for Group Travel Pune, Pune Tempo Traveller Service, Affordable Tempo Traveller Pune, Tempo Traveller on Rent for Tours Pune, Pune Tempo Traveller Rent Rates, Pune Tempo Traveller with Driver, Tempo Traveller for Family Trips Pune, Pune Tempo Traveller for Corporate Events, Tempo Traveller for Pilgrimage Trips Pune, Pune Tempo Traveller for School Trips, Tempo Traveller Hire Pune with AC"
  />
  <script type="application/ld+json">
    {JSON.stringify(tempoTravellerOnRentPuneSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/18.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Tempotravelleronrentinpune;